import seedrandom from "seedrandom";
import { Vector3 } from "three";

const LAT_LON_NOISE = 0.00001;

/**
 * Converts degrees, minutes, seconds format to decimal
 * @param degrees angle in degrees
 * @param minutes angle in minutes
 * @param seconds angle in seconds
 * @return angle in decimal
 */
export const sexagesimalToDecimal = (degrees, minutes, seconds) => {
  return degrees + minutes / 60 + seconds / 3600;
};

/**
 * Converts meters to feet
 * @param meters distance in meters
 * @return distance in feet
 */
export const metersToFeet = (meters) => {
  return meters * 3.28084;
};

/**
 * Converts feet to meters
 * @param feet distance in feet
 * @return distance in meters
 */
export const feetToMeters = (feet) => {
  return feet / 3.28084;
};

/**
 * Converts degrees to radians
 * @param meters angle in degrees
 * @return angle in radians
 */
export const degreesToRadians = (degrees) => {
  return degrees * (Math.PI / 180);
};

/**
 * Computes new coordinates based on a seed
 * @param coordinates original coordinates
 * @param seed seed for random number generator
 * @param keysToIgnore keys to not randomize
 * @return new coordinates
 */
export const randomizeCoordinates = (coordinates, seed, keysToIgnore) => {
  let newCoordinates = {};
  const rng = seedrandom(seed);

  for (const [key, value] of Object.entries(coordinates)) {
    newCoordinates[key] = { ...value };
    if (!keysToIgnore.includes(key)) {
      newCoordinates[key] = {
        ...value,
        lat: (rng() - 0.5) * 2 * LAT_LON_NOISE + value["lat"],
        lon: (rng() - 0.5) * 2 * LAT_LON_NOISE + value["lon"]
      };
    }
  }

  return newCoordinates;
};

/**
 * Calculates the distance between two points
 * @param {Vector3 | Object} fromPoint - The starting point (either a Vector3 or an object with x, y, z properties)
 * @param {Vector3 | Object} toPoint - The ending point (either a Vector3 or an object with x, y, z properties)
 * @returns {number} The distance between the two points, in scene units
 */
export const calculateDistance = (fromPoint, toPoint) => {
  if (typeof fromPoint !== Vector3) {
    fromPoint = new Vector3(fromPoint.x, fromPoint.y, fromPoint.z);
  }
  if (typeof toPoint !== Vector3) {
    toPoint = new Vector3(toPoint.x, toPoint.y, toPoint.z);
  }
  return fromPoint.distanceTo(toPoint);
};
